// extracted by mini-css-extract-plugin
export var banner = "ticketsBanner-module--banner--8MrhN";
export var banner__ctaContainer = "ticketsBanner-module--banner__ctaContainer--tvTX4";
export var banner__description = "ticketsBanner-module--banner__description--VvGgj";
export var banner__inner = "ticketsBanner-module--banner__inner--cIVU0";
export var banner__link = "ticketsBanner-module--banner__link--NTOs3";
export var banner__wrapper = "ticketsBanner-module--banner__wrapper--tAqev";